import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { Typography, Tabs, Tab } from "@material-ui/core";

import {
    getAllQualifications,
    setCurrentTable,
    getQualificationCategories,
    setPageIndex,
    setRowCount,
    setCategory,
    addQualification,
    removeQualification,
    getUsers,
    setSnackbarState,
    getCustomQualifications,
    createCustomQualification,
    editCustomQualification,
    setViewValidUsersModalInfo,
    getAreas, getDepartments
} from "./actions";
import {
    selectCurrentTable,
    selectFilteredQualifications,
    selectPageIndex,
    selectRowCount,
    selectQualificationCategories,
    selectCategory,
    selectPostFail,
    selectPostSuccess,
    selectNewQualificationIdAndCustomQualificationPrefix,
    selectValidUsersPerQualification,
    selectTotalValidUsers,
    selectNumberOfCustomQualifications,
    selectViewValidUsersModalInfo,
    selectUserInfoForViewQualificationModal,
    selectInfoForQualificationOverview,
    getRequesting,
    canUpdate,
    canCreate,
    canDelete,
    selectProfile
} from "./selectors";
import { Modal, ModalBody, Spinner } from "reactstrap";
import { StyledCard, StyledContent, StyledHeader } from "../../styles";

import {
    QualificationsTable,
    Snackbar,
    QualificationsOverview,
} from "./Components";

const TabsBar = styled(Tabs)`
    border: 0px solid black;
    width: fit-content;
    border-radius: 5px;
    background-color: white;
`;
class QualificationsManager extends Component {
    constructor(props) {
        super(props);
        props.getAllQualifications();
        props.getQualificationCategories();
        props.getUsers();
        props.getCustomQualifications();
        props.getAreas();
        props.getDepartments();
        this.state = { postFail: false, postSuccess: false };
    }

    render() {
        const {
            currentTable,

            postFail,
            postSuccess,

            totalValidUsers,

            qualificationsOverviewInfo,
            userProfile
        } = this.props;
        return (
            <StyledCard>
                <>
                    <StyledHeader>
                        <Typography variant="h5">
                            Qualifications Manager
                        </Typography>
                    </StyledHeader>
                    <StyledContent>
                        <Modal
                            isOpen={this.props.requesting}
                            style={{ maxWidth: "00px" }}
                        >
                            <ModalBody>
                                <div
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "3em",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "white",
                                            width: "fit-content",
                                            display: "inline-block",
                                            padding: "2em",
                                        }}
                                    >
                                        <Spinner
                                            style={{
                                                height: 100,
                                                width: 100,
                                                background: "white",
                                            }}
                                            color="primary"
                                        />
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                marginTop: 15,
                                                color: "rgba(0, 0, 0, 0.87)",
                                                fontWeight: "bolder",
                                                fontSize: 20,
                                            }}
                                            variant="body2"
                                        >
                                            Processing...
                                        </Typography>
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>
                        <TabsBar
                            value={currentTable}
                            onChange={(event, value) =>
                                this.props.setCurrentTable(value)
                            }
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab
                                value="required"
                                label={
                                    <span style={{ color: "green" }}>
                                        Assigned Qualifications
                                    </span>
                                }
                            />
                            <Tab
                                value="available"
                                label={
                                    <span style={{ color: "red" }}>
                                        UnAssigned Qualifications
                                    </span>
                                }
                            />
                            <Tab
                                value="overview"
                                label={
                                    <span style={{ color: "blue" }}>
                                        Qualifications overview 
                                    </span>
                                }
                            />
                        </TabsBar>

                        {(currentTable === "available" ||
                            currentTable === "required") && (
                            <QualificationsTable {...this.props} />
                        )}
                        {currentTable === "overview" && (
                            <QualificationsOverview
                                overViewInfo={qualificationsOverviewInfo}
                                userProfile={userProfile}
                                totalValidUsers={totalValidUsers}
                            />
                        )}
                        <Snackbar
                            open={postSuccess || postFail}
                            message={
                                postSuccess
                                    ? "Qualification Successfully Updated"
                                    : postFail
                                    ? "Unable To Update Qualification, Please Contact System Admin"
                                    : ""
                            }
                            color={
                                postSuccess ? "green" : postFail ? "red" : ""
                            }
                            onClose={() => this.props.setSnackbarState(false)}
                        />
                    </StyledContent>
                </>
            </StyledCard>
        );
    }
}

export default connect(
    (store) => {
        
        return {
            currentTable: selectCurrentTable(store),
            requesting: getRequesting(store),
            filteredQualifications: selectFilteredQualifications(store),
            pageIndex: selectPageIndex(store),
            rowCount: selectRowCount(store),
            categories: selectQualificationCategories(store),
            category: selectCategory(store),
            postFail: selectPostFail(store),
            postSuccess: selectPostSuccess(store),
            newQualificationInfo: selectNewQualificationIdAndCustomQualificationPrefix(
                store
            ),
            usersPerQualification: selectValidUsersPerQualification(store),
            totalValidUsers: selectTotalValidUsers(store),
            numberOfCustomQualifications: selectNumberOfCustomQualifications(
                store
            ),
            viewValidUsersModalInfo: selectViewValidUsersModalInfo(store),
            viewQualificationModalUserInfo: selectUserInfoForViewQualificationModal(
                store
            ),
            qualificationsOverviewInfo: selectInfoForQualificationOverview(
                store
            ),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
            userProfile: selectProfile(store),
        };
    },
    {
        getAllQualifications,
        setCurrentTable,
        getQualificationCategories,
        setPageIndex,
        setRowCount,
        setCategory,
        addQualification,
        removeQualification,
        getUsers,
        setSnackbarState,
        getCustomQualifications,
        createCustomQualification,
        editCustomQualification,
        setViewValidUsersModalInfo,
        getAreas, getDepartments
    }
)(QualificationsManager);
